import ServiceLocator from "../../../../global/service-locator";
import EventEmitter from "../event-emitter";

export default class TelInput {
    constructor(props = {}) {
        this.props = props;

        this.$root = this.props.$root;

        this.modalService = ServiceLocator.instance.modalService;

        this.maskPattern = null;
        this.iti = null;
        this.selectedCountry = null;
        this.valid = false;

        this._value = null;
        this._eventEmitter = new EventEmitter(this.props.subscriptions || []);

        this.BEFORE_INIT_EVENT = 'beforeInit';
        this.AFTER_INIT_EVENT = 'afterInit';
        this.VALUE_CHANGE_EVENT = 'valueChange';
        this.BLUR_EVENT = 'blur';
        this.VALIDATION_STATUS_CHANGE_EVENT = 'validationStatusChange';

        this._init();
    }

    setValue(value) {
        let updatedValue = value;

        if (updatedValue) {
            if (updatedValue.length > 9) {
                updatedValue = updatedValue.replace(/^\+?380/, '');
            }

            updatedValue = updatedValue.replace(/[\s-]/g, '');
        }

        if (updatedValue === this._value) {
            return;
        }

        this._value = updatedValue;
        this.$root.value = VMasker.toPattern(this._value || '', this.maskPattern);
        this.$root.dispatchEvent(new Event('input'));
    }

    getValue() {
        return this.iti.getNumber().replace(/[\s-]/g, '');
    }

    _init() {
        this._checkProps();
        this._eventEmitter.dispatch(this.BEFORE_INIT_EVENT);
        this._initComponents();
        this._addSubscriptions();
        this._bootstrap();
    }

    _checkProps() {
        if (!this.$root) {
            throw new Error('TelInput: Root element not found!');
        }
    }

    _initComponents() {
        this.iti = intlTelInput(this.$root, {
            utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@23.6.1/build/js/utils.js',
            initialCountry: 'ua',
            nationalMode: false,
            separateDialCode: true,
            countryOrder: ['ua', 'us'],
            excludeCountries: ['ru', 'by', 'kz', 'am', 'kg', 'tj']
        });
    }

    _addSubscriptions() {
        this.$root.addEventListener('input', this._handleInput.bind(this));
        this.$root.addEventListener('blur', this._handleBlur.bind(this));
        this.$root.addEventListener('countrychange', this._handleCountryChange.bind(this));
        this.$root.addEventListener('open:countrydropdown', this._handleCoutryDropdownOpen.bind(this));
        this.$root.addEventListener('close:countrydropdown', this._handleCoutryDropdownClose.bind(this));
    }

    _bootstrap() {
        return this.iti.promise.then(() => {
            this.$root.parentElement.querySelectorAll('.iti__flag').forEach(item => {
                item.dataset.backgroundImage = (`${craft.env.assetsSiteUrl + '/assets/images/Extensions/flags.png'}`);
                item.classList.add('lozad');
            });
            lozadObserver.observe();
            this._getMaskPattern();
            this._initInputMask();

            if (this.$root.value) {
                this.$root.dispatchEvent(new Event('input'));
            }

            this._eventEmitter.dispatch(this.AFTER_INIT_EVENT);
        });
    }

    _initInputMask() {
        VMasker(this.$root).maskPattern(this.maskPattern);
    }

    _getMaskPattern() {
        this.selectedCountry = this.iti.getSelectedCountryData().iso2;

        const numberExample = intlTelInput.utils.getExampleNumber(this.selectedCountry, false, 1);
        let pattern = numberExample.split(' ');
        pattern.shift();
        this.maskPattern = pattern.join(' ').replace(/\d/g, '9');

        // Allow numbers with several digit number for these countries
        if (this.selectedCountry === 'bg') {
            this.maskPattern += '9';
        } else if (this.selectedCountry === 'at') {
            this.maskPattern += '99';
        }
    }

    _validate() {
        let updatedValidationStatus = intlTelInput.utils.isValidNumber(this._value, this.iti.getSelectedCountryData().iso2);
        const exampleNumberLength = this.maskPattern.split(' ').join('').length;

        if (!updatedValidationStatus &&
            this._value &&
            this._value.length === exampleNumberLength &&
            (this.selectedCountry === 'bg' ||
                // Bug fix when a valid israel phone number does not pass validation
                this.selectedCountry === 'il' && this._value.slice(0, 2) === '55')) {
            updatedValidationStatus = true;
        }

        if (updatedValidationStatus === this.valid) {
            return;
        }

        this.valid = updatedValidationStatus;
        this._eventEmitter.dispatch(this.VALIDATION_STATUS_CHANGE_EVENT, this.valid);
    }

    _handleInput(e) {
        let value = e.target.value;

        if (value.length > 9) {
            value = value.replace(/^\+?380/, '');
        }

        this.$root.value = VMasker.toPattern(value, this.maskPattern);
        this._value = this.$root.value;
        this._validate();
        this._eventEmitter.dispatch(this.VALUE_CHANGE_EVENT, this.getValue());
    }

    _handleBlur() {
        this._eventEmitter.dispatch(this.BLUR_EVENT);
    }

    _handleCountryChange() {
        this._getMaskPattern();
        this._initInputMask();
        this.setValue(null);
    }

    _handleCoutryDropdownOpen() {
        const $countryListbox = this.$root.parentElement.querySelector('.iti__country-list[role="listbox"]');

        if (this.props.intlDropdownPositions === 'above') {
            const  $countryContainer = this.$root.parentElement.querySelector('.iti__country-container');
            const  $countryListboxDropdown = this.$root.parentElement.querySelector('.iti__dropdown-content');

            $countryListboxDropdown.style.bottom = $countryContainer.offsetHeight + 'px';
        }

        if (this.modalService.isOpened) {
            scrollLock.disablePageScroll($countryListbox);
        }

        $countryListbox.querySelectorAll('.iti__flag').forEach(item => {
            item.dataset.backgroundImage = (`${craft.env.assetsSiteUrl + '/assets/images/Extensions/flags.png'}`);
            item.classList.add('lozad');
        });
        lozadObserver.observe();
    }

    _handleCoutryDropdownClose() {
        if (this.modalService.isOpened) {
            const $countryListbox = document.getElementById('country-listbox');
            scrollLock.enablePageScroll($countryListbox);
        }
    }
}